import { StorageIds } from '../constants/storage'
import { FeatureScreenType } from '../types/servicesTypes/configTypes'

export const setFeatureScreenCount = (id: string) => {
  try {
    const storageCounters = JSON.parse(localStorage.getItem(StorageIds.featureScreenCounters) || '{}')
    const screenCount = Number(storageCounters[id]) || 0
    storageCounters[id] = screenCount + 1
    localStorage.setItem(StorageIds.featureScreenCounters, JSON.stringify(storageCounters))
  } catch (error) {
    return console.error('Error updating feature screen count:', error)
  }
}

export const getFeatureScreenCount = (id: string) => {
  try {
    const storageCounters = JSON.parse(localStorage.getItem(StorageIds.featureScreenCounters) || '{}')
    return Number(storageCounters[id]) || 0
  } catch (error) {
    return 0
  }
}

export const getValidFeatureScreen = (featureScreens?: FeatureScreenType[]) => {
  return featureScreens?.find((featureScreen) => {
    const featureScreenCounter = featureScreen.counter
    const localCounter = getFeatureScreenCount(featureScreen.id)
    return Boolean(featureScreenCounter && localCounter < featureScreenCounter)
  })
}
